/**
 * The wire identity of a workflow export file — shared so the two sides of
 * import/export cannot disagree about it.
 *
 * A workflow exports to a JSON file that a person can hand to someone on another
 * account, so the file is a contract between a WRITER (the server's export route)
 * and two READERS: the server's import route, and the browser, which validates the
 * picked file before uploading it so a wrong file fails instantly with a useful
 * message instead of a round trip.
 *
 * These constants lived in both `apps/server/.../workflowPortable.ts` and
 * `apps/web/.../workflowTransfer.ts` under different names. That is exactly the
 * shape of bug versioning is supposed to prevent: bump one copy and the other
 * silently rejects files it should accept, or accepts files it cannot read. They
 * live here instead, because both packages already depend on `@t3tools/contracts`.
 *
 * BUMPING THE VERSION: raise it only when an older reader would MIS-read a newer
 * file. Adding an optional field is not a bump — readers ignore what they do not
 * know. Changing the meaning of an existing field, or making a new field load
 * bearing, is. When you do bump it, decide deliberately whether the importer should
 * still accept the previous version rather than leaving everyone's saved files dead.
 */

/** `app` stamp on the file; a file carrying a different one is not ours to read. */
export const WORKFLOW_EXPORT_APP = "morrowos";

/** `formatVersion` the current code writes, and the only one it can read. */
export const WORKFLOW_EXPORT_VERSION = 1;
